<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div class="box" v-loading.fullscreen.lock="fullscreenLoading">
      <export_excel :json_data="json_data" :json_fields="json_fields" name="户外广告.xls" car_placard="广告"/>
      <placard_screen path_arr="path_array1" :category_id="7" @screen_confirm="pageChange(1)"
                      @reset_screen="pageChange(1)"/>
      <Title title="资源列表"/>
      <div class="table_box">
        <el-table :data="tableData" stripe>
          <el-table-column width="130" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="头像">
            <template slot-scope="scope">
              <img :src="scope.row.heads" style="width: 60px;"/>
            </template>
          </el-table-column>
          <el-table-column min-width="130" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="姓名">
            <template slot-scope="scope">
              <el_table_column column_type="text" prop="title" :scope="scope"/>
            </template>
          </el-table-column>
          <el-table-column width="130" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="性别">
            <template slot-scope="scope">
              <el_table_column column_type="text" prop="age_title" :scope="scope"/>
            </template>
          </el-table-column>
          <el-table-column width="130" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="职业">
            <template slot-scope="scope">
              <el_table_column column_type="text" prop="career_title" :scope="scope"/>
            </template>
          </el-table-column>
          <el-table-column width="130" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="地域">
            <template slot-scope="scope">
              <el_table_column column_type="text" prop="area_title" :scope="scope"/>
            </template>
          </el-table-column>
          <el-table-column width="130" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="年代">
            <template slot-scope="scope">
              <el_table_column column_type="text" prop="years_title" :scope="scope"/>
            </template>
          </el-table-column>
          <el-table-column width="480" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="予以对接-商务类型">
            <template slot-scope="scope">
              <el_table_column column_type="text" prop="category_title" :scope="scope"/>
            </template>
          </el-table-column>
          <!--          <el-table-column width="100" current-row-key="currentRowKey" label-class-name="custom-header-class"-->
          <!--                           class-name="custom-column-cell" header-align="center" align="center" label="设计单位">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el_table_column column_type="text" prop="design_unit_text" :scope="scope"/>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column width="150" current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="翻包-参考报价">
            <template slot-scope="scope">
              <el_table_column  column_type="button_money" prop="member_price_7" :scope="scope"/>
            </template>
          </el-table-column>
          <el-table-column current-row-key="currentRowKey" label-class-name="custom-header-class"
                           class-name="custom-column-cell" header-align="center" align="center" label="与我联系">
          <template slot-scope="scope">
            <!--              <img :src="scope.row.pic_url" style="width: 70px;height: 120px"/>-->
            <el-tooltip class="item" effect="dark" content="点击预览大图" placement="right">
              <el-image
                  style="width: 70px;"
                  :src="scope.row.ercode"
                  :preview-src-list="[scope.row.ercode]">
              </el-image>
            </el-tooltip>
          </template>
          </el-table-column>
          <el-table-column header-align="center" label-class-name="custom-header-class"
                         class-name="custom-column-cell" fixed="right" align="center" width="130" label="操作">
          <template slot-scope="scope">
            <el_table_column column_type="controls" :scope="scope" @collect_status="collect_status"/>
          </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <pagination style="padding: 10px" :page="page" @pageChange="pageChange" :count="count"
                    :total_page="total_page"/>
      </div>
      <!-- 购物车 -->
      <!-- <placard_shop_car :tableDate="tableData" :showCar="showCar" @delete_item="delete_item" @empty="empty"
                        @excelPush="excelPush"/> -->

    </div>
  </div>
</template>

<script>

import {mapState, mapMutations} from 'vuex'
import placard_screen from '@/components/talet_screen'//公共-类别与筛选项-插件引用
import el_table_column from '@/components/el_table_columntalet'//公共-列数据-插件引用
import {media_screen_} from '@/util/media_screen_'

export default {
  components: {
    placard_screen,
    el_table_column,
  },
  computed: {
    ...mapState(['hongren']),
  },

  data() {
    return {
      tableData: [],
      fullscreenLoading: false,
      total_page: 0, //分页总页数
      count: 0, //总条数
      page: 1,
      showCar: false,
    }
  },
  methods: {
    pageChange(pageVal) {
      this.page = pageVal
      this.get_list()
    },
    collect_status(status, index) {
      this.tableData[index].is_collect = status
      // this.get_list()
    },
    // 获取列表数据
    get_list() {
      this.fullscreenLoading = true
      let data = media_screen_(this.hongren.date_form)
      data.page = this.page
      data.limit = 10
      this.curlGet('/api/hongren/info/list', data).then(res => {
        if (res.data.code) {
          this.tableData = res.data.data.list
          this.total_page = res.data.data.total_page
          this.count = res.data.data.count
          this.tableData.forEach((item, index) => {
            this.$set(this.tableData[index], 'check', false)
            this.$set(this.tableData[index], 'type', '')
            this.$set(this.tableData[index], 'cycle', 1)
          })
        }
        this.fullscreenLoading = false
      })
    },
  },
}
</script>

<style lang=scss scoped>
@use '@/scss/placard_media';
</style>